import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
export const getReference = async (cleaner_id:any, id:any, visible?:any) => {
    const queryParams = new URLSearchParams();  
      if (cleaner_id) queryParams.append('cleaner_id', cleaner_id.toString());
      if (id) queryParams.append('id', id.toString());
      if (visible) queryParams.append('visible_to_employer', visible)
  try {
        return await get<ApiResponse<[]>>(`/cleaner/references?${queryParams}`).then((res)=> {
            if(res.success===true) {
                return res
            }
            else {
                return null
            }
        })
  }
  catch(e:any){
    HandleApiError(e);
            return null
    

  }

}
